import { useOrganization } from '@clerk/react';
import { RiAddLine } from '@remixicon/react';
import { ClerkRole } from '@shared/constants';
import { useFormik } from 'formik';
import { DrawerId, SideDrawer, SideDrawerHeader, useSideDrawer } from 'src/components/containers/SideDrawer';
import { AgButton, AgInput, AgSelect } from 'src/components/ui';

type InviteForm = { email: string; role: ClerkRole };

const roleOptions = [
  { value: ClerkRole.Member, label: 'User' },
  { value: ClerkRole.Admin, label: 'Admin' },
];

export function InviteMember({ canInvite }) {
  const { organization: clerkOrg } = useOrganization();
  const { openDrawer, closeDrawer } = useSideDrawer();

  const f = useFormik<InviteForm>({
    initialValues: { email: '', role: ClerkRole.Member },
    onSubmit: (values, { resetForm }) => {
      clerkOrg.inviteMember({ emailAddress: values.email, role: values.role });
      resetForm();
      closeDrawer();
    },
  });

  return (
    <>
      <AgButton onPress={() => openDrawer(DrawerId.INVITE_MEMBER)} isDisabled={!canInvite} variant="primary">
        <RiAddLine size={20} />
        Add Member
      </AgButton>
      <SideDrawer drawerId={DrawerId.INVITE_MEMBER}>
        <SideDrawerHeader title="Add Member" />
        <form onSubmit={f.handleSubmit}>
          <div className="flex min-w-[356px] flex-col gap-6">
            <AgInput
              autoFocus
              type="email"
              label="Email Address"
              name="email"
              value={f.values.email}
              onChange={(value) => f.setFieldValue('email', value)}
              onBlur={() => f.setFieldTouched('email', true)}
              isInvalid={f.touched.email && !!f.errors.email}
              errorMessage={f.touched.email ? f.errors.email : undefined}
            />
            <AgSelect
              label="Role"
              options={roleOptions}
              value={f.values.role}
              onChange={(key) => f.setFieldValue('role', key)}
            />
            <AgButton type="submit" variant="primary" className="self-end">
              Send Invite
            </AgButton>
          </div>
        </form>
      </SideDrawer>
    </>
  );
}
